export const ORDER_ITEM_EXTENT = {
    profiles: true,
    rebateItems: true,
    rebatedItems: true,
    depositComplement: true,
};
